import React from 'react';
import NavBar from './components/NavBar'
import WorkArea from './components/WorkArea'
import './App.scss';

function App() {
  return (
    <>
     <NavBar/> 
     <WorkArea/>
    </>
  );
}

export default App;
